import { useMemo } from 'react';

import { useColor } from 'hooks';
import { TranslationPath } from 'libs/i18n';
import { Icon } from 'libs/ui/Icon';
import { SvgProps } from 'libs/ui/Icon/icons/types';
import { ColorsDark, ColorsLight, ColorType } from 'libs/ui/theme';

import { ActionType } from '../../types';

export interface ActionConfig {
  label: TranslationPath;
  Icon: React.FC<SvgProps>;
  color?: SvgProps['color'];
  borderColor?: ColorType | string;
}

export const useActionsMap = (): Record<ActionType, ActionConfig> => {
  const deleteColor = useColor({
    light: ColorsLight.red100,
    dark: ColorsDark.red100,
  });

  const downloadColor = useColor({
    light: ColorsLight.black,
    dark: ColorsDark.white,
  });

  return useMemo(
    () => ({
      [ActionType.Sign]: {
        label: 'account.order.actions.sign',
        Icon: Icon.DocEdit,
      },
      [ActionType.Edit]: {
        label: 'common.edit',
        Icon: Icon.Edit,
      },
      [ActionType.Delete]: {
        label: 'common.delete',
        Icon: Icon.Bucket,
        color: deleteColor,
        borderColor: deleteColor,
      },
      [ActionType.Download]: {
        label: 'common.download',
        Icon: Icon.Download,
        color: downloadColor,
      },
    }),
    [deleteColor, downloadColor]
  );
};
